// extracted by mini-css-extract-plugin
export var card = "styles-module--card--4c327";
export var container = "styles-module--container--1dec0";
export var grid = "styles-module--grid--dcc99";
export var h1 = "styles-module--h-1--14318";
export var h2 = "styles-module--h-2--6ca00";
export var h3 = "styles-module--h-3--158c8";
export var h4 = "styles-module--h-4--7e6a8";
export var h5 = "styles-module--h-5--9942f";
export var h6 = "styles-module--h-6--a5dc1";
export var highlighted = "styles-module--highlighted--2ba3a";
export var p1 = "styles-module--p-1--a524c";
export var p2 = "styles-module--p-2--eb55d";
export var p3 = "styles-module--p-3--207cd";
export var p4 = "styles-module--p-4--51d7d";
export var slim = "styles-module--slim--7d897";
export var title = "styles-module--title--71791";